export { renderDrawerFooter_unstable as renderDrawerFooter } from '@fluentui/react-drawer';
